















import { defineComponent, ref, computed, PropType, toRefs, nextTick } from '@vue/composition-api';
import { AdgroupConfig, AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { useAdgroupMode } from '@tt4b/ttam-hooks';

import ProductSourceType from './index';

const name = 'ttam-product-source-type-compose';
export default defineComponent({
  name,
  components: {
    TtamProductSourceType: ProductSourceType.TtamProductSourceType,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, createMode, campaignData } = toRefs(props);
    const formItem = ref(null);
    const { isEdit, isCreate, isCopy } = useAdgroupMode({ createMode });
    // const { state } = useStore();

    const productSource = computed({
      get: () => adgroupData.value.productSource,
      set: val => {
        emit('change', { productSource: val });
        emit('input', val);
        // 手动触发校验更新状态
        nextTick(() => formItem.value?.validate('change'));
      },
    });

    const { productSourceTypeValidator } = ProductSourceType.useRules();
    const { loadProductSourceShow } = ProductSourceType.useProductSourceShow();

    // const isShopEmpty = computed(() => !state.storeList.data.value?.length);
    // const { visible } = ProductSourceType.usePropsVisible({ campaignData, adgroupData, isShopEmpty });
    const { list } = ProductSourceType.usePropsList({ isCreate, campaignData, adgroupData });

    loadProductSourceShow();

    return {
      isEdit,
      isCopy,
      productSource,
      // visible,
      list,
      productSourceTypeValidator,
    };
  },
});
